import { Skeleton } from "@/components/atoms/Skeleton/Skeleton";

interface Props {
  /** Extra line before the 32h block (the variant used while fetching text). */
  extraLine?: boolean;
}

export function ArtifactSkeleton({ extraLine }: Props) {
  return (
    <div className="space-y-3 p-4" data-sentry-component="ArtifactSkeleton" data-sentry-source-file="ArtifactSkeleton.tsx">
      <Skeleton variant="translucent" className="h-4 w-3/4" data-sentry-element="Skeleton" data-sentry-source-file="ArtifactSkeleton.tsx" />
      <Skeleton variant="translucent" className="h-4 w-1/2" data-sentry-element="Skeleton" data-sentry-source-file="ArtifactSkeleton.tsx" />
      {extraLine && <Skeleton variant="translucent" className="h-4 w-5/6" />}
      <Skeleton variant="translucent" className="h-32 w-full" data-sentry-element="Skeleton" data-sentry-source-file="ArtifactSkeleton.tsx" />
    </div>
  );
}
